/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fit_Known_Ray_EditInputs */

const fr_fit_known_ray_edit = /** @type {(inputs: Fit_Known_Ray_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date d'expiration`)
};

/**

* @param {Fit_Known_Ray_EditInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fit_known_ray_edit = /** @type {((inputs?: Fit_Known_Ray_EditInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fit_Known_Ray_EditInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fit_known_ray_edit(inputs)
});